import { useSelector } from 'react-redux';
import OnboardingBeacons from 'growth-onboarding-beacon/OnboardingBeacons';
import { PERSONALIZATION_BEACON_CONFIGS } from 'personalization-lib/constants/onboarding';
import { getIsUsingPersonalization } from '../redux/selectors/pageContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizationOnboardingBeacons = () => {
  const isUsingPersonalization = useSelector(getIsUsingPersonalization);
  return isUsingPersonalization && /*#__PURE__*/_jsx(OnboardingBeacons, {
    beaconsConfigId: PERSONALIZATION_BEACON_CONFIGS.VARIANT_SELECT
  });
};
export default PersonalizationOnboardingBeacons;